import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';
import { FaGithub, FaLinkedin, FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const serviceId = 'service_tuf5zzy';
      const publicKey = 'ydXpQC1g9CuZSfE5B';

      const notificationTemplateId = 'template_m9nejtd'; 
      const notificationParams = {
        to_email: 'wajihaniazi22@gmail.com', 
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        time: new Date().toLocaleString(), 
      };
      await emailjs.send(serviceId, notificationTemplateId, notificationParams, publicKey);

      setStatus('Message sent successfully! I will get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus('Error sending message. Please try again.');
    }
  };

  return (
    <section id="contact" className="py-12 sm:py-16 md:py-20 bg-beige-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-navy-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-beige-400 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 relative z-10">
        <motion.div
          className="text-center mb-10 sm:mb-12 md:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-beige-600 font-semibold text-xs sm:text-sm uppercase tracking-wider">
            Let's Connect
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-900 mt-2 font-primary">
            Get In Touch
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-beige-500 mx-auto mt-3 sm:mt-4"></div>
          <p className="mt-4 sm:mt-6 text-gray-600 max-w-2xl mx-auto text-sm sm:text-base px-4">
            I'd love to hear from you! Whether it's a project, job opportunity, or just a chat,
            feel free to reach out.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 max-w-6xl mx-auto">
          {/* Contact Info */}
          <motion.div
            className="space-y-6 sm:space-y-8"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-beige-200">
              <h3 className="text-xl sm:text-2xl font-bold text-navy-900 mb-4 sm:mb-6 font-primary">
                Contact Information
              </h3>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-beige-50 rounded-lg sm:rounded-xl hover:bg-beige-100 transition-colors">
                  <div className="p-2 sm:p-3 bg-navy-100 rounded-lg flex-shrink-0">
                    <HiMail className="text-xl sm:text-2xl text-navy-700" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs sm:text-sm text-gray-600">Email</p>
                    <a href="mailto:wajihaniazi22@gmail.com" className="text-navy-900 font-medium hover:text-navy-700 text-sm sm:text-base break-all">
                      wajihaniazi22@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-beige-50 rounded-lg sm:rounded-xl hover:bg-beige-100 transition-colors">
                  <div className="p-2 sm:p-3 bg-navy-100 rounded-lg flex-shrink-0">
                    <HiPhone className="text-xl sm:text-2xl text-navy-700" />
                  </div>
                  <div>
                    <p className="text-xs sm:text-sm text-gray-600">Phone</p>
                    <a href="tel:+93793292204" className="text-navy-900 font-medium hover:text-navy-700 text-sm sm:text-base">
                      +93 79 329 2204
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-beige-50 rounded-lg sm:rounded-xl hover:bg-beige-100 transition-colors">
                  <div className="p-2 sm:p-3 bg-navy-100 rounded-lg flex-shrink-0">
                    <HiLocationMarker className="text-xl sm:text-2xl text-navy-700" />
                  </div>
                  <div>
                    <p className="text-xs sm:text-sm text-gray-600">Location</p>
                    <p className="text-navy-900 font-medium text-sm sm:text-base">Herat, Afghanistan</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg">
              <h3 className="text-lg sm:text-xl font-bold text-beige-300 mb-3 sm:mb-4 font-primary">
                Follow Me
              </h3>
              <div className="flex flex-wrap gap-2 sm:gap-3">
                {[
                  { Icon: FaGithub, href: 'https://github.com/WajihaNiazi', label: 'GitHub' },
                  { Icon: FaLinkedin, href: 'https://www.linkedin.com/in/wajiha-niazi-9b4991200/', label: 'LinkedIn' },
                  { Icon: FaInstagram, href: 'https://www.instagram.com/eng.wajihaniazi/?hl=en', label: 'Instagram' },
                  { Icon: FaFacebook, href: 'https://www.facebook.com/eng.wajihaniazi/', label: 'Facebook' },
                  { Icon: FaTwitter, href: 'https://x.com/Wajiha_Niazi', label: 'Twitter' },
                ].map(({ Icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 sm:p-3 bg-charcoal-700/50 rounded-lg hover:bg-beige-500/20 border border-charcoal-600 hover:border-beige-400 transition-all duration-300 hover:scale-110 group"
                    aria-label={label}
                  >
                    <Icon className="text-xl sm:text-2xl text-beige-200 group-hover:text-beige-300" />
                  </a>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.form
            onSubmit={handleSubmit}
            className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-beige-200"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-xl sm:text-2xl font-bold text-navy-900 mb-3 sm:mb-4 font-primary">
              Send Me a Message
            </h3>

            <div className="space-y-3 sm:space-y-4">
              <div>
                <label htmlFor="name" className="block text-navy-900 font-medium mb-1 text-xs sm:text-sm">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-beige-500 focus:border-transparent transition-all text-sm sm:text-base"
                  placeholder="Ali"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-navy-900 font-medium mb-1 text-xs sm:text-sm">
                  Your Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-beige-500 focus:border-transparent transition-all text-sm sm:text-base"
                  placeholder="ali@example.com"
                  required
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-navy-900 font-medium mb-1 text-xs sm:text-sm">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-beige-500 focus:border-transparent transition-all text-sm sm:text-base"
                  placeholder="Project inquiry, job opportunity, etc."
                  required
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-navy-900 font-medium mb-1 text-xs sm:text-sm">
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-beige-500 focus:border-transparent transition-all resize-none text-sm sm:text-base"
                  placeholder="Tell me about your project..."
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full py-2.5 sm:py-3 bg-gradient-to-r from-beige-500 to-beige-600 text-navy-900 font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-beige-400 hover:to-beige-500 focus:outline-none focus:ring-2 focus:ring-beige-500 transition-all duration-300 hover:scale-105 text-sm sm:text-base"
              >
                Send Message
              </button>

              {status && (
                <p className={`mt-2 text-center font-medium text-xs sm:text-sm ${status.includes('Error') ? 'text-red-600' : 'text-green-600'}`}>
                  {status}
                </p>
              )}
            </div>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
